// Names may only contain Latin letters, spaces, hyphens and apostrophes --
// curly (U+2018/U+2019), modifier (U+02BC), acute (U+00B4) and grave (U+0060).
// The plain ASCII apostrophe (U+0027) and double quote (U+0022) are NOT allowed:
// Mangopay's bank-account/recipient creation errors on the plain apostrophe.
// Letters = ASCII + Latin-1 / Extended-A / Extended-B (U+00C0..U+024F) plus
// combining marks (U+0300..U+036F), so both precomposed ("é") and decomposed
// ("e" + combining acute) accents are accepted and stored as-is -- Mangopay
// accepts both, so we do NOT normalize. Matches the API allowlist exactly.
// No \p{}/u-flag regex: the production browserslist targets IE11 / old Safari,
// which don't support Unicode property escapes. Digits, punctuation
// (( ) & , . : _ /), symbols, emoji and non-Latin scripts are rejected.
// eslint-disable-next-line no-misleading-character-class -- combining marks are intentional (no /u available)
const DISALLOWED_NAME_CHARS = /[^a-zA-ZÀ-ÖØ-öø-ɏ\u0300-\u036F ‘’ʼ´`-]/;

export const hasSpecialChars = (value) => {
  if (value === undefined || value === null) {
    return false;
  }
  return DISALLOWED_NAME_CHARS.test(String(value));
};

export const FIRST_NAME_SPECIAL_CHARS_ERROR = {
  id: 'userForm.firstNameSpecialChars',
  defaultMessage: "The first name can't include special characters, such as: ( ) & , . : _ /",
};

export const LAST_NAME_SPECIAL_CHARS_ERROR = {
  id: 'userForm.lastNameSpecialChars',
  defaultMessage: "The last name can't include special characters, such as: ( ) & , . : _ /",
};
